import React, { Component } from "react";
import styles from "./NotificationBar.css";
import MenuToggle from "../MenuToggle/MenuToggle";

function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function cookieName(hash) {
  return `notificationbar_${hash}`;
}
const cookieClosed = "closed";

class NotificationBar extends Component {
  constructor(props) {
    super(props);

    this.onClose = this.onClose.bind(this);

    this.state = {
      visible: false,
      closed: false,
    };
  }

  componentDidMount() {
    if (getCookie(cookieName(this.props.hash)) !== cookieClosed) {
      this.setState({ visible: true });
    }
  }

  onClose() {
    setCookie(cookieName(this.props.hash), cookieClosed, 7);
    this.setState({ closed: true });
  }

  render() {
    const { showPageAsInfoScreen } = this.props;
    return (
      <div
        style={{ display: this.state.visible ? "block" : "none" }}
        className={[
          styles.wrapper,
          showPageAsInfoScreen ? styles.wrapper_infoScreen : "",
          this.state.closed ? styles.hidden : "",
        ].join(" ")}
      >
        <div
          className={styles.closeAction}
          style={{
            display: showPageAsInfoScreen ? "none" : "block",
          }}
        >
          <MenuToggle isOpen={true} onMenuToggle={this.onClose} />
        </div>
        <div
          className={styles.contentContainer}
          style={{ opacity: this.state.closed ? 0 : 1 }}
        >
          <div
            className={[
              styles.content,
              showPageAsInfoScreen ? styles.content_infoScreen : "",
            ].join(" ")}
            dangerouslySetInnerHTML={{ __html: this.props.message }}
          />
        </div>
      </div>
    );
  }
}

export default NotificationBar;



// WEBPACK FOOTER //
// ./src/components/NotificationBar/NotificationBar.js